// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"697df2d0","239":"7966f111","287":"b6ee3cd7","455":"a9c5f00e","977":"71d2e416"}[chunkId] + ".chunk.js";
};